/*
  cb_chart
*/
/**
 * Desktop/Mobile Inline Simple Chart for Cashback amounts
 */

/************************************************
		PLUGIN INIT
*************************************************/
$('.actual-amount-chart').jQMeter({goal:'250',raised:'0',height:'15px',animationSpeed:0,displayTotal:false});
